import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Youtube } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_492015e1-693c-4b93-9925-0425bdd75ac8/artifacts/xddhsh4h_file_00000000615871faa3e076794ff10c47.jpg"
                alt="Vijaya Dental Clinic"
                className="h-20 w-auto object-contain mb-3"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Certified BPS Denture Specialist with 16+ years of experience providing comprehensive dental care.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" data-testid="footer-link-home" className="text-slate-300 hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-slate-300 hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="text-slate-300 hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/gallery" data-testid="footer-link-gallery" className="text-slate-300 hover:text-primary transition-colors">Gallery</Link></li>
              <li><Link to="/testimonials" data-testid="footer-link-testimonials" className="text-slate-300 hover:text-primary transition-colors">Testimonials</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-slate-300 hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                <span className="text-slate-300 text-sm">
                  opp. Railway Station, New Shahupuri, Kolhapur, Maharashtra 416001
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary" />
                <a href="tel:09975727098" data-testid="footer-phone" className="text-slate-300 hover:text-primary transition-colors">099757 27098</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary" />
                <a href="mailto:team@vijayadentalclinic.org" data-testid="footer-email" className="text-slate-300 hover:text-primary transition-colors">team@vijayadentalclinic.org</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Clinic Hours</h4>
            <div className="flex items-start gap-3 mb-6">
              <Clock className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
              <div className="text-sm text-slate-300">
                <p>Monday - Saturday</p>
                <p className="font-semibold text-white">10:00 AM - 8:00 PM</p>
                <p className="mt-2">Sunday</p>
                <p className="font-semibold text-white">10:00 AM - 6:00 PM</p>
              </div>
            </div>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/vijayadentalclinic.official" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-primary transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/p/DM-k8xYtNBR/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-primary transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@chandrashekharharale/shorts" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-primary transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} Dr Harale's Vijaya Dental Clinic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
